import React from "react";
import { useSelector } from "react-redux";

import { userProfiles } from "../../redux/slices/UserProfilesSlice";
import { selectMaterialRequestHistoryResults } from "../../redux/slices/materialRequestHistorySlice";
import NotAllowed from "../../components/NotAllowed/NotAllowed";
import RequestHistorySearchForm from "../../components/Forms/RequestHistorySearchForm/RequestHistorySearchForm";
import RequestHistoryTable from "../../components/RequestHistoryTable/RequestHistoryTable";
import { useMaterialRequest } from "../../hooks/useMaterialRequest";

function RequestHistory() {
  const reduxUserProfiles = useSelector(userProfiles);
  const requestHistory = useSelector(selectMaterialRequestHistoryResults);
  const { fetchRequestHistory } = useMaterialRequest();

  const isLoading = reduxUserProfiles?.isLoading;
  const hasContracts =
    reduxUserProfiles?.data && reduxUserProfiles.data.length > 0;

  if (isLoading || !hasContracts) {
    return (
      <NotAllowed
        isUserAllowed={hasContracts}
        isLoading={isLoading}
        loadingMessage="Cargando contratos..."
        notAllowedMessage={
          <>
            <h2>No ha sido posible recuperar los contratos del cliente.</h2>
            <h2>
              Póngase en contacto con su comercial de la cuenta/operaciones de
              Correos Frio.
            </h2>
          </>
        }
      />
    );
  }

  return (
    <div className="RequestHistory">
      <h2>Historial de peticiones</h2>

      <RequestHistorySearchForm
        reduxUserProfiles={reduxUserProfiles}
        fetchRequestHistory={fetchRequestHistory}
        requestHistory={requestHistory}
      />

      <RequestHistoryTable
        requestHistory={requestHistory}
        fetchRequestHistory={fetchRequestHistory}
      />
    </div>
  );
}

export default RequestHistory;
